var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 13.803,
    height: 11.311,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6097",
    "data-name": "Group 6097",
    transform: "translate(-323 -2285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(323 2285)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6071",
    "data-name": "Group 6071",
    transform: "translate(334.406 2297.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6040",
    "data-name": "Group 6040",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8528",
    "data-name": "Path 8528",
    d: "M0,10.094A6.058,6.058,0,0,0,4.088,8.866a2.95,2.95,0,0,1-2.651-2H2.644a2.99,2.99,0,0,1-2.18-2.86,2.892,2.892,0,0,0,1.227.3A2.873,2.873,0,0,1,.473,2.019,2.61,2.61,0,0,1,.865.533,8.157,8.157,0,0,0,6.734,3.508c-.019-.136-.041-.246-.05-.357A2.863,2.863,0,0,1,9.9.027a2.813,2.813,0,0,1,1.6.762.249.249,0,0,0,.287.075C12.318.674,12.854.488,13.39.3A2.824,2.824,0,0,1,12.262,1.74l.026.059L13.8,1.385c-.238.282-.441.547-.67.787a5.758,5.758,0,0,1-.6.53.354.354,0,0,0-.143.312,8.151,8.151,0,0,1-3.827,7.12,7.272,7.272,0,0,1-3.127,1.1,8.13,8.13,0,0,1-5.324-1.07c-.037-.022-.072-.048-.108-.072",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.81653e1f7df38331a245baf1f6fb3ae2.svg";
export { ForwardRef as ReactComponent };